// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching member side */
.admin-dashboard-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

/* === HEADER === */
.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 3rem;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
    position: sticky;
    top: 0;
    z-index: 10;
}

.header-left,
.header-right,
.header-center {
    flex: 1 1;
}

.header-left {
    display: flex;
    justify-content: flex-start;
}

.header-center {
    display: flex;
    justify-content: center;
}

.header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 2.5rem;
}

.datetime-display {
    font-size: 1.15rem;
    color: #475569;
    font-weight: 600;
}

.logo-placeholder {
    height: 55px;
    width: 55px;
    background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.center-logo {
    height: 100%;
    width: 100%;
    object-fit: contain;
    border-radius: 50%;
}

.user-profile-section {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    white-space: nowrap;
}

.welcome-text {
    font-size: 1.1rem;
    font-weight: 600;
    color: #334155;
}

.icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #64748b;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    padding: 0.5rem;
    border-radius: 50%;
}

.icon-btn:hover {
    color: #0f172a;
    background-color: #f1f5f9;
}

.logout-btn:hover {
    color: #ef4444;
    background-color: #fef2f2;
}

.badge {
    position: absolute;
    top: 0px;
    right: 0px;
    background: #ef4444;
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    height: 18px;
    min-width: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
}

/* === MAIN CONTENT === */
.admin-main-content {
    padding: 2.5rem 3rem 5rem 3rem;
    max-width: 1400px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

.section-heading {
    font-size: 1.35rem;
    color: #334155;
    font-weight: 700;
    margin: 0 0 1.5rem 0;
    letter-spacing: -0.5px;
}

.admin-divider {
    border: none;
    height: 1px;
    background: #cbd5e1;
    margin: 3.5rem 0;
}

/* === PROFESSIONAL COLOR PALETTE === */
.icon-slate {
    background: #f1f5f9;
    color: #475569;
}

.icon-navy {
    background: #e0e7ff;
    color: #3730a3;
}

.icon-emerald {
    background: #ecfdf5;
    color: #059669;
}

.icon-rose {
    background: #fff1f2;
    color: #e11d48;
}

.text-slate {
    color: #475569;
}

.text-navy {
    color: #3730a3;
}

.text-emerald {
    color: #059669;
}

.text-rose {
    color: #e11d48;
}

.badge-slate {
    background: #475569;
}

.badge-navy {
    background: #3730a3;
}

.badge-emerald {
    background: #059669;
}

.badge-rose {
    background: #e11d48;
}


/* === ADMIN STATS GRID (NEW STACKED DESIGN) === */
.adm-stats-grid {
    display: grid;
    /* Desktop layout handles 4 columns to fit 7 cards efficiently */
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    margin-bottom: 2rem;
}

.adm-stat-card {
    background: white;
    padding: 1.15rem;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.adm-border-rose {
    border-bottom: 3px solid #e11d48;
}

.adm-border-emerald {
    border-bottom: 3px solid #059669;
}

.adm-border-navy {
    border-bottom: 3px solid #3730a3;
}

.adm-border-slate {
    border-bottom: 3px solid #475569;
}

.adm-stat-top {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}

.adm-stat-icon {
    height: 38px;
    width: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.adm-stat-svg {
    width: 20px;
    height: 20px;
}

.adm-stat-top p {
    margin: 0;
    color: #64748b;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1.2;
}

.adm-stat-bottom h3 {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 800;
    word-break: break-word;
}

/* Make Cash in Hand stretch across 2 columns on Desktop */
.adm-card-full {
    grid-column: span 2;
}

/* === ACTION CARDS GRID (Bottom Section) === */
.admin-actions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
}

.action-card {
    background: white;
    border-radius: 20px;
    padding: 2rem 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    cursor: pointer;
    position: relative;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.action-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05);
    border-color: #cbd5e1;
}

.action-icon-wrapper {
    height: 60px;
    width: 60px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
}

.action-content h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.25rem;
    color: #1e293b;
    font-weight: 700;
}

.action-content p {
    margin: 0;
    font-size: 0.95rem;
    color: #64748b;
    line-height: 1.5;
}

/* Smart Badges on Action Cards */
.action-smart-badge {
    position: absolute;
    top: -10px;
    right: 20px;
    padding: 0.3rem 0.85rem;
    border-radius: 99px;
    color: white;
    font-weight: 600;
    font-size: 0.8rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 2px solid white;
}

/* === RESPONSIVE DESIGN === */
@media (max-width: 1024px) {
    .dashboard-header {
        flex-direction: column;
        gap: 1.25rem;
        padding: 1.5rem;
    }

    .header-left,
    .header-center,
    .header-right {
        justify-content: center;
        width: 100%;
    }

    .admin-main-content {
        padding: 2rem 1.5rem;
    }
}

/* Exact mapping for Tablet/Mobile layout (2 Columns, 4 Rows) */
@media (max-width: 768px) {
    .adm-stats-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.65rem;
    }

    .adm-card-full {
        grid-column: span 2;
        /* Cash in Hand spans full width row 3 */
    }

    .adm-stat-card {
        padding: 0.85rem;
        gap: 0.6rem;
    }

    .adm-stat-icon {
        height: 32px;
        width: 32px;
    }

    .adm-stat-svg {
        width: 16px;
        height: 16px;
    }

    .adm-stat-top p {
        font-size: 0.75rem;
    }

    .adm-stat-bottom h3 {
        font-size: 1.25rem;
    }
}

@media (max-width: 600px) {
    .admin-actions-grid {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Dashboard.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;IAC3C,2BAA2B;IAC3B,iDAAiD;IACjD,0CAA0C;IAC1C,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;;;IAGI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,6DAA6D;IAC7D,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA,kDAAkD;AAClD;IACI,aAAa;IACb,gEAAgE;IAChE,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,0DAA0D;AAC1D;IACI,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,4DAA4D;AAChE;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,uBAAuB;AAC3B;;AAEA,8BAA8B;AAC9B;IACI;QACI,sBAAsB;QACtB,YAAY;QACZ,eAAe;IACnB;;IAEA;;;QAGI,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA,+DAA+D;AAC/D;IACI;QACI,qCAAqC;QACrC,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,wCAAwC;IAC5C;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Container matching member side */\n.admin-dashboard-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n/* === HEADER === */\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem 3rem;\n    background-color: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(10px);\n    border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.header-left,\n.header-right,\n.header-center {\n    flex: 1;\n}\n\n.header-left {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.header-center {\n    display: flex;\n    justify-content: center;\n}\n\n.header-right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 2.5rem;\n}\n\n.datetime-display {\n    font-size: 1.15rem;\n    color: #475569;\n    font-weight: 600;\n}\n\n.logo-placeholder {\n    height: 55px;\n    width: 55px;\n    background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n}\n\n.center-logo {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n    border-radius: 50%;\n}\n\n.user-profile-section {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    white-space: nowrap;\n}\n\n.welcome-text {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #334155;\n}\n\n.icon-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #64748b;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n    padding: 0.5rem;\n    border-radius: 50%;\n}\n\n.icon-btn:hover {\n    color: #0f172a;\n    background-color: #f1f5f9;\n}\n\n.logout-btn:hover {\n    color: #ef4444;\n    background-color: #fef2f2;\n}\n\n.badge {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    background: #ef4444;\n    color: white;\n    font-size: 0.75rem;\n    font-weight: bold;\n    height: 18px;\n    min-width: 18px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid white;\n}\n\n/* === MAIN CONTENT === */\n.admin-main-content {\n    padding: 2.5rem 3rem 5rem 3rem;\n    max-width: 1400px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.section-heading {\n    font-size: 1.35rem;\n    color: #334155;\n    font-weight: 700;\n    margin: 0 0 1.5rem 0;\n    letter-spacing: -0.5px;\n}\n\n.admin-divider {\n    border: none;\n    height: 1px;\n    background: #cbd5e1;\n    margin: 3.5rem 0;\n}\n\n/* === PROFESSIONAL COLOR PALETTE === */\n.icon-slate {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n.icon-navy {\n    background: #e0e7ff;\n    color: #3730a3;\n}\n\n.icon-emerald {\n    background: #ecfdf5;\n    color: #059669;\n}\n\n.icon-rose {\n    background: #fff1f2;\n    color: #e11d48;\n}\n\n.text-slate {\n    color: #475569;\n}\n\n.text-navy {\n    color: #3730a3;\n}\n\n.text-emerald {\n    color: #059669;\n}\n\n.text-rose {\n    color: #e11d48;\n}\n\n.badge-slate {\n    background: #475569;\n}\n\n.badge-navy {\n    background: #3730a3;\n}\n\n.badge-emerald {\n    background: #059669;\n}\n\n.badge-rose {\n    background: #e11d48;\n}\n\n\n/* === ADMIN STATS GRID (NEW STACKED DESIGN) === */\n.adm-stats-grid {\n    display: grid;\n    /* Desktop layout handles 4 columns to fit 7 cards efficiently */\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.adm-stat-card {\n    background: white;\n    padding: 1.15rem;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.adm-border-rose {\n    border-bottom: 3px solid #e11d48;\n}\n\n.adm-border-emerald {\n    border-bottom: 3px solid #059669;\n}\n\n.adm-border-navy {\n    border-bottom: 3px solid #3730a3;\n}\n\n.adm-border-slate {\n    border-bottom: 3px solid #475569;\n}\n\n.adm-stat-top {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n}\n\n.adm-stat-icon {\n    height: 38px;\n    width: 38px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.adm-stat-svg {\n    width: 20px;\n    height: 20px;\n}\n\n.adm-stat-top p {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    line-height: 1.2;\n}\n\n.adm-stat-bottom h3 {\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 800;\n    word-break: break-word;\n}\n\n/* Make Cash in Hand stretch across 2 columns on Desktop */\n.adm-card-full {\n    grid-column: span 2;\n}\n\n/* === ACTION CARDS GRID (Bottom Section) === */\n.admin-actions-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 1.5rem;\n}\n\n.action-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2rem 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.action-card:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05);\n    border-color: #cbd5e1;\n}\n\n.action-icon-wrapper {\n    height: 60px;\n    width: 60px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n}\n\n.action-content h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1.25rem;\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.action-content p {\n    margin: 0;\n    font-size: 0.95rem;\n    color: #64748b;\n    line-height: 1.5;\n}\n\n/* Smart Badges on Action Cards */\n.action-smart-badge {\n    position: absolute;\n    top: -10px;\n    right: 20px;\n    padding: 0.3rem 0.85rem;\n    border-radius: 99px;\n    color: white;\n    font-weight: 600;\n    font-size: 0.8rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border: 2px solid white;\n}\n\n/* === RESPONSIVE DESIGN === */\n@media (max-width: 1024px) {\n    .dashboard-header {\n        flex-direction: column;\n        gap: 1.25rem;\n        padding: 1.5rem;\n    }\n\n    .header-left,\n    .header-center,\n    .header-right {\n        justify-content: center;\n        width: 100%;\n    }\n\n    .admin-main-content {\n        padding: 2rem 1.5rem;\n    }\n}\n\n/* Exact mapping for Tablet/Mobile layout (2 Columns, 4 Rows) */\n@media (max-width: 768px) {\n    .adm-stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 0.65rem;\n    }\n\n    .adm-card-full {\n        grid-column: span 2;\n        /* Cash in Hand spans full width row 3 */\n    }\n\n    .adm-stat-card {\n        padding: 0.85rem;\n        gap: 0.6rem;\n    }\n\n    .adm-stat-icon {\n        height: 32px;\n        width: 32px;\n    }\n\n    .adm-stat-svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    .adm-stat-top p {\n        font-size: 0.75rem;\n    }\n\n    .adm-stat-bottom h3 {\n        font-size: 1.25rem;\n    }\n}\n\n@media (max-width: 600px) {\n    .admin-actions-grid {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
